import { type MouseEvent, useState } from 'react';

import { Button, Menu, MenuItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

const StyledHeaderDiv = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
`;

const StyledPageTitle = styled(Typography)`
    font-size: 24px;
`;

const StyledButtonDiv = styled.div`
    display: flex;
    margin-left: auto;
`;

const IntegrationsHeader: React.FC = () => {
    const { t } = useTranslation('admin_settings');
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { path } = useRouteMatch();
    const onList = !path.includes('/create') && !path.includes('/edit');
    const history = useHistory();

    const handleCreateClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        history.push(`${path}/create`);
    };

    const handleMenuClick = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const menuList = [
        {
            title: 'blackboard',
            url: 'https://help.blackboard.com/Learn/Administrator/SaaS/Integrations/Learning_Tools_Interoperability'
        },
        {
            title: 'canvas',
            url: 'https://community.canvaslms.com/t5/Admin-Guide/How-do-I-configure-an-external-app-for-an-account-using-XML/ta-p/221'
        },
        {
            title: 'd2l',
            url: 'https://documentation.brightspace.com/EN/le/lti/admin/lti_standards_support.htm'
        },
        {
            title: 'moodle',
            url: 'https://docs.moodle.org/310/en/External_tool_settings'
        },
        {
            title: 'sakai',
            url: 'https://longsight.screenstepslive.com/s/4586/m/30369/c/103752'
        },
        {
            title: 'schoology',
            url: 'https://support.schoology.com/hc/en-us/articles/204377963-A-How-to-Guide-for-Schoology-s-LTI-Integration'
        }
    ];
    return (
        <StyledHeaderDiv>
            <StyledPageTitle variant='h1'>{t('lms-integration')}</StyledPageTitle>
            <StyledButtonDiv>
                {
                    onList &&
                    <Button
                        variant="contained"
                        onClick={handleCreateClick}
                    >
                        {t('create')}
                    </Button>
                }
                <Button
                    id="documentation-button"
                    sx={{ marginLeft: onList ? '12px' : '0px' }}
                    variant="outlined"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleMenuClick}
                >
                    {t('documentation')}
                </Button>
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'documentation-button'
                    }}
                >
                    {menuList.map((item, index) => (
                        <MenuItem key={index} onClick={handleClose}>
                            <a href={item.url} target='_blank'>
                                {t(item.title)}
                            </a>
                        </MenuItem>
                    ))}
                </Menu>

            </StyledButtonDiv>
        </StyledHeaderDiv>
    );
};

export default IntegrationsHeader;
